(function (window, document) {
    'use strict';

    var widgetSelector = '.custom-form-widget';
    var formContainerSelector = '.custom-form-widget__form';
    var successMessageSelector = '.formwidget-submit-text';
    var enhancedAttribute = 'data-custom-form-focus-ready';
    var preventDuplicateAttribute = 'data-prevent-duplicate-submissions';
    var submittingAttribute = 'data-custom-form-submitting';
    var submittingClass = 'custom-form-widget--submitting';
    var submitButtonSelector = 'input[type="submit"], button[type="submit"]';
    var submissionStatusSelector = '.custom-form-widget__submission-status';
    var submittingText = 'Submitting...';
    var helperMarker = '__svhaCustomFormSubmissionProgress';
    var requireAhpraAttribute = 'data-require-ahpra-registration';
    var ahpraValidationReadyAttribute = 'data-ahpra-validation-ready';
    var ahpraRadioSelector = 'input[type="radio"][name*="AHPRARegistered"], input[type="radio"][id*="AHPRARegistered"]';
    var ahpraErrorClass = 'custom-form-widget__ahpra-error';
    var ahpraInvalidFieldClass = 'custom-form-widget__ahpra-field--invalid';
    var ahpraBlockedClass = 'custom-form-widget--ahpra-blocked';
    var ahpraDisabledAttribute = 'data-ahpra-disabled';
    var ahpraValidationMessage = 'Thanks for your interest in St Vincent’s. Current AHPRA registration is required for these nursing and midwifery opportunities. We’d love to hear from you once you’re registered.';
    var ahpraMessageCounter = 0;

    function findWidget(element) {
        var current = element;

        while (current && current !== document) {
            if (current.classList && current.classList.contains('custom-form-widget')) {
                return current;
            }

            current = current.parentElement;
        }

        return null;
    }

    function findFormField(element) {
        var current = element;

        while (current && current !== document) {
            if (current.classList && current.classList.contains('form-field')) {
                return current;
            }

            current = current.parentElement;
        }

        return null;
    }

    function getRadioLabel(radio) {
        var sibling = radio.nextElementSibling;

        if (sibling && sibling.tagName === 'LABEL') {
            return sibling;
        }

        if (radio.parentElement) {
            return radio.parentElement.querySelector('label');
        }

        return null;
    }

    function isAffirmativeAhpraChoice(radio) {
        if (!radio) {
            return false;
        }

        var value = (radio.value || '').replace(/^\s+|\s+$/g, '').toLowerCase();

        if (value === 'yes' || value === 'true' || value === '1') {
            return true;
        }

        var label = getRadioLabel(radio);
        var labelText = label ? (label.textContent || label.innerText || '') : '';

        return labelText.replace(/^\s+|\s+$/g, '').toLowerCase() === 'yes';
    }

    function isAhpraRadio(element) {
        if (!element || element.tagName !== 'INPUT' || (element.type || '').toLowerCase() !== 'radio') {
            return false;
        }

        return (element.name || '').indexOf('AHPRARegistered') >= 0
            || (element.id || '').indexOf('AHPRARegistered') >= 0;
    }

    function getSelectedAhpraChoice(radios) {
        for (var index = 0; index < radios.length; index += 1) {
            if (radios[index].checked) {
                return radios[index];
            }
        }

        return null;
    }

    function updateAhpraSubmitAvailability(widget, form, selectedRadio) {
        var shouldDisable = selectedRadio && !isAffirmativeAhpraChoice(selectedRadio);
        var buttons = form.querySelectorAll(submitButtonSelector);

        if (shouldDisable) {
            widget.classList.add(ahpraBlockedClass);
        } else {
            widget.classList.remove(ahpraBlockedClass);
        }

        for (var index = 0; index < buttons.length; index += 1) {
            var button = buttons[index];

            if (shouldDisable) {
                if (button.getAttribute(ahpraDisabledAttribute) === 'true'
                    || button.disabled
                    || button.getAttribute('aria-disabled') === 'true') {
                    continue;
                }

                button.setAttribute(ahpraDisabledAttribute, 'true');
                button.disabled = true;
                button.setAttribute('aria-disabled', 'true');
                continue;
            }

            if (button.getAttribute(ahpraDisabledAttribute) !== 'true') {
                continue;
            }

            button.removeAttribute(ahpraDisabledAttribute);

            if (widget.getAttribute(submittingAttribute) !== 'true') {
                button.disabled = false;
                button.removeAttribute('aria-disabled');
            }
        }
    }

    function updateDescribedBy(input, messageId, add) {
        var currentValue = input.getAttribute('aria-describedby') || '';
        var currentIds = currentValue.split(/\s+/);
        var updatedIds = [];
        var hasMessageId = false;

        for (var index = 0; index < currentIds.length; index += 1) {
            var currentId = currentIds[index];

            if (!currentId) {
                continue;
            }

            if (currentId === messageId) {
                hasMessageId = true;

                if (!add) {
                    continue;
                }
            }

            updatedIds.push(currentId);
        }

        if (add && !hasMessageId) {
            updatedIds.push(messageId);
        }

        if (updatedIds.length) {
            input.setAttribute('aria-describedby', updatedIds.join(' '));
        } else {
            input.removeAttribute('aria-describedby');
        }
    }

    function clearAhpraValidation(radios) {
        var field = radios.length ? findFormField(radios[0]) : null;
        var message = field ? field.querySelector('.' + ahpraErrorClass) : null;
        var messageId = message ? message.id : '';

        if (field) {
            field.classList.remove(ahpraInvalidFieldClass);
        }

        for (var index = 0; index < radios.length; index += 1) {
            radios[index].classList.remove('input-validation-error');
            radios[index].removeAttribute('aria-invalid');

            if (messageId) {
                updateDescribedBy(radios[index], messageId, false);
            }
        }

        if (message && message.parentNode) {
            message.parentNode.removeChild(message);
        }
    }

    function showAhpraValidation(radios, focusInvalid) {
        if (!radios.length) {
            return;
        }

        var field = findFormField(radios[0]);

        if (!field) {
            return;
        }

        var message = field.querySelector('.' + ahpraErrorClass);

        if (!message) {
            ahpraMessageCounter += 1;
            message = document.createElement('span');
            message.id = 'ahpra-registration-error-' + ahpraMessageCounter;
            message.className = 'field-validation-error ' + ahpraErrorClass;
            message.setAttribute('role', 'alert');
            message.textContent = ahpraValidationMessage;
            field.appendChild(message);
        }

        field.classList.add(ahpraInvalidFieldClass);

        var selectedRadio = null;

        for (var index = 0; index < radios.length; index += 1) {
            var radio = radios[index];

            radio.classList.add('input-validation-error');
            radio.setAttribute('aria-invalid', 'true');
            updateDescribedBy(radio, message.id, true);

            if (radio.checked) {
                selectedRadio = radio;
            }
        }

        if (focusInvalid) {
            (selectedRadio || radios[0]).focus();
        }
    }

    function validateAhpraRegistration(widget, form, focusInvalid) {
        if (widget.getAttribute(requireAhpraAttribute) !== 'true') {
            return true;
        }

        var radios = form.querySelectorAll(ahpraRadioSelector);
        var selectedRadio = getSelectedAhpraChoice(radios);

        updateAhpraSubmitAvailability(widget, form, selectedRadio);

        if (selectedRadio && isAffirmativeAhpraChoice(selectedRadio)) {
            clearAhpraValidation(radios);
            return true;
        }

        showAhpraValidation(radios, focusInvalid);
        return false;
    }

    function initialiseAhpraValidation(widget, formContainer) {
        if (widget.getAttribute(requireAhpraAttribute) !== 'true') {
            return;
        }

        var form = formContainer.querySelector('form');

        if (!form) {
            return;
        }

        var radios = form.querySelectorAll(ahpraRadioSelector);

        if (!radios.length) {
            return;
        }

        updateAhpraSubmitAvailability(widget, form, getSelectedAhpraChoice(radios));

        if (form.getAttribute(ahpraValidationReadyAttribute) === 'true') {
            return;
        }

        form.setAttribute(ahpraValidationReadyAttribute, 'true');

        form.addEventListener('change', function (event) {
            if (isAhpraRadio(event.target)) {
                validateAhpraRegistration(widget, form, false);
            }
        });

        form.addEventListener('submit', function (event) {
            if (!validateAhpraRegistration(widget, form, true)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }, true);
    }

    function passesClientValidation(form) {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            return false;
        }

        if (!window.jQuery) {
            return true;
        }

        try {
            var jqueryForm = window.jQuery(form);
            var validator = jqueryForm.data('validator');

            if (!validator && jqueryForm.data('unobtrusiveValidation') && typeof jqueryForm.validate === 'function') {
                validator = jqueryForm.validate();
            }

            if (!validator) {
                return true;
            }

            if (typeof validator.form === 'function' && !validator.form()) {
                return false;
            }

            return !validator.pendingRequest;
        } catch (error) {
            // Fall back to Kentico's existing submission flow if validation cannot be inspected.
            return true;
        }
    }

    function setButtonText(button, value) {
        if (button.tagName === 'INPUT') {
            button.value = value;
        } else {
            button.textContent = value;
        }
    }

    function ensureSubmissionStatus(widget) {
        var status = widget.querySelector(submissionStatusSelector);

        if (!status) {
            status = document.createElement('span');
            status.className = 'sr-only custom-form-widget__submission-status';
            status.setAttribute('role', 'status');
            status.setAttribute('aria-live', 'polite');
            status.setAttribute('aria-atomic', 'true');
            widget.appendChild(status);
        }

        return status;
    }

    function beginSubmission(widget, form) {
        var formContainer = widget.querySelector(formContainerSelector);
        var buttons = form.querySelectorAll(submitButtonSelector);
        var buttonStates = [];
        var status = ensureSubmissionStatus(widget);

        widget.setAttribute(submittingAttribute, 'true');
        widget.classList.add(submittingClass);
        form.setAttribute('aria-busy', 'true');

        if (formContainer) {
            formContainer.setAttribute('aria-busy', 'true');
        }

        for (var index = 0; index < buttons.length; index += 1) {
            var button = buttons[index];

            buttonStates.push({
                element: button,
                wasDisabled: button.disabled,
                hadAriaDisabled: button.hasAttribute('aria-disabled'),
                ariaDisabled: button.getAttribute('aria-disabled'),
                text: button.tagName === 'INPUT' ? button.value : button.innerHTML
            });

            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            setButtonText(button, submittingText);
        }

        status.textContent = submittingText;

        return {
            widget: widget,
            form: form,
            formContainer: formContainer,
            buttons: buttonStates,
            status: status,
            complete: false
        };
    }

    function endSubmission(state) {
        if (!state || state.complete) {
            return;
        }

        state.complete = true;
        state.widget.removeAttribute(submittingAttribute);
        state.widget.classList.remove(submittingClass);
        state.form.removeAttribute('aria-busy');

        if (state.formContainer) {
            state.formContainer.removeAttribute('aria-busy');
        }

        for (var index = 0; index < state.buttons.length; index += 1) {
            var buttonState = state.buttons[index];
            var button = buttonState.element;

            button.disabled = buttonState.wasDisabled;

            if (buttonState.hadAriaDisabled) {
                button.setAttribute('aria-disabled', buttonState.ariaDisabled);
            } else {
                button.removeAttribute('aria-disabled');
            }

            if (button.tagName === 'INPUT') {
                button.value = buttonState.text;
            } else {
                button.innerHTML = buttonState.text;
            }
        }

        if (state.status) {
            state.status.textContent = '';
        }

        if (state.widget.getAttribute(requireAhpraAttribute) === 'true') {
            var radios = state.form.querySelectorAll(ahpraRadioSelector);
            updateAhpraSubmitAvailability(state.widget, state.form, getSelectedAhpraChoice(radios));
        }
    }

    function submitWithProgress(originalSubmit, context, args, widget, form) {
        var xhrPrototype = window.XMLHttpRequest && window.XMLHttpRequest.prototype;

        if (!xhrPrototype || typeof xhrPrototype.send !== 'function') {
            return originalSubmit.apply(context, args);
        }

        var originalSend = xhrPrototype.send;
        var requestCaptured = false;
        var interceptedSend = function () {
            xhrPrototype.send = originalSend;

            if (requestCaptured) {
                return originalSend.apply(this, arguments);
            }

            requestCaptured = true;

            var request = this;
            var submissionState = beginSubmission(widget, form);

            try {
                request.addEventListener('loadend', function () {
                    endSubmission(submissionState);
                });

                return originalSend.apply(request, arguments);
            } catch (error) {
                endSubmission(submissionState);
                throw error;
            }
        };

        xhrPrototype.send = interceptedSend;

        try {
            return originalSubmit.apply(context, args);
        } finally {
            if (xhrPrototype.send === interceptedSend) {
                xhrPrototype.send = originalSend;
            }
        }
    }

    function enhanceKenticoSubmitHelper() {
        var helper = window.kentico && window.kentico.updatableFormHelper;

        if (!helper || typeof helper.submitForm !== 'function' || helper.submitForm[helperMarker]) {
            return;
        }

        var originalSubmit = helper.submitForm;
        var enhancedSubmit = function (event) {
            var form = event && event.target;
            var widget = form && findWidget(form);

            if (!widget || widget.getAttribute(preventDuplicateAttribute) !== 'true') {
                return originalSubmit.apply(this, arguments);
            }

            if (widget.getAttribute(submittingAttribute) === 'true') {
                event.preventDefault();
                event.stopImmediatePropagation();
                return false;
            }

            if (!passesClientValidation(form)) {
                event.preventDefault();
                return false;
            }

            return submitWithProgress(originalSubmit, this, arguments, widget, form);
        };

        enhancedSubmit[helperMarker] = true;
        helper.submitForm = enhancedSubmit;
    }

    function focusSuccessMessage(message) {
        if (!message || message.getAttribute(enhancedAttribute) === 'true') {
            return;
        }

        message.setAttribute(enhancedAttribute, 'true');
        message.setAttribute('tabindex', '-1');

        window.setTimeout(function () {
            try {
                message.focus({ preventScroll: true });
            } catch (error) {
                message.focus();
            }

            if (message.scrollIntoView) {
                var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

                message.scrollIntoView({
                    behavior: reduceMotion ? 'auto' : 'smooth',
                    block: 'center'
                });
            }
        }, 0);
    }

    function initialiseWidget(widget) {
        var formContainer = widget.querySelector(formContainerSelector);

        if (!formContainer) {
            return;
        }

        focusSuccessMessage(formContainer.querySelector(successMessageSelector));
        initialiseAhpraValidation(widget, formContainer);

        if (!window.MutationObserver) {
            return;
        }

        var observer = new window.MutationObserver(function () {
            focusSuccessMessage(formContainer.querySelector(successMessageSelector));
            initialiseAhpraValidation(widget, formContainer);
        });

        observer.observe(formContainer, {
            childList: true,
            subtree: true
        });
    }

    function initialise() {
        var widgets = document.querySelectorAll(widgetSelector);
        var hasSubmissionProgress = false;

        for (var index = 0; index < widgets.length; index += 1) {
            initialiseWidget(widgets[index]);

            if (widgets[index].getAttribute(preventDuplicateAttribute) === 'true') {
                hasSubmissionProgress = true;
                ensureSubmissionStatus(widgets[index]);
            }
        }

        if (hasSubmissionProgress) {
            enhanceKenticoSubmitHelper();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialise);
    } else {
        initialise();
    }
}(window, document));
